// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"d4efaf98","787":"01ee8190"}[chunkId] + ".chunk.js";
};